import '../../bins/parts/bin-path-name';
import '../../common/bn-property';
import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class WorkOrderBinHeading extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity) {
      return html``;
    }
    return html`
      <h3><organization-ancestors-bread-crumbs .href="${this.getHref('https://api.binsentry.com/rel/owner')}" .stopAtType="account"></organization-ancestors-bread-crumbs></h3>
      <h2><bin-name .href="${this.href}"></bin-name></h2>
    `;
  }
}

window.customElements.define('work-order-bin-heading', WorkOrderBinHeading);
